import {
  CALENDAR_ITEM_STATUS_PROPS,
  CalendarItemStatusName,
} from '../../Calendar.constants'

export function getCalendarItemCardStatusTags({ isArchived, isDue }) {
  return [
    isDue ? CALENDAR_ITEM_STATUS_PROPS[CalendarItemStatusName.due] : null,
    isArchived
      ? CALENDAR_ITEM_STATUS_PROPS[CalendarItemStatusName.archived]
      : null,
  ].filter(Boolean)
}
